export const listEncabezadosTipoContrato = [
  {
    id: 1,
    title: "NOMBRE DEL EMPLEADO Y DOCUMENTO DE IDENTIDAD:",
  },
  {
    id: 2,
    title: "DIRECCIÓN DEL EMPLEADOR:",
  },
  {
    id: 3,
    title: "NOMBRE APELLIDOS DEL TRABAJADOR Y DOCUMENTO DE IDENTIDAD:",
  },
  {
    id: 4,
    title: "DIRECCIÓN DEL TRABAJADOR:",
  },
  {
    id: 5,
    title: "LUGAR Y FECHA DE NACIMIENTO DEL TRABAJADOR:",
  },
  {
    id: 6,
    title: "NACIONALIDAD:",
  },
  {
    id: 7,
    title: "SALARIO:",
  },
  {
    id: 8,
    title: "CARGO U OFICIO A DESEMPEÑAR:",
  },
  {
    id: 9,
    title: "PERIODOS DE PAGO:",
  },
  {
    id: 10,
    title: "FECHA DE INICIO DE LABORES:",
  },
  {
    id: 11,
    title: "LUGAR DONDE DESEMPEÑA LAS LABORES:",
  },
  {
    id: 12,
    title: "LUGAR DONDE HA SIDO CONTRATADO EL TRABAJADOR:",
  },
];

export const listClauses = [
  {
    clauseId: 1,
    idTipoContrato: 1,
    title: "Cláusula 168594",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent turpis tortor, consequat interdum sagittis vitae, feugiat sit amet quam. In eu accumsan enim. Nullam laoreet tempus urna in ultricies. Morbi porta ut ligula quis congue.",
  },
  {
    clauseId: 2,
    idTipoContrato: null,
    title: "Cláusula 168595",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent turpis tortor, consequat interdum sagittis vitae, feugiat sit amet quam. In eu accumsan enim. Nullam laoreet tempus urna in ultricies. Morbi porta ut ligula quis congue.",
  },
  {
    clauseId: 3,
    idTipoContrato: null,
    title: "Cláusula 168596",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent turpis tortor, consequat interdum sagittis vitae, feugiat sit amet quam. In eu accumsan enim. Nullam laoreet tempus urna in ultricies. Morbi porta ut ligula quis congue.",
  },
];

export const numeroOrdinal = [
  "primera",
  "segunda",
  "tercera",
  "cuarta",
  "quinta",
  "sexta",
  "séptima",
  "octava",
  "novena",
  "décima",
  "undécima",
  "duodécima",
  "décima tercera",
  "décima cuarta",
  "décima quinta",
  "décima sexta",
  "décima séptima",
  "décima octava",
  "décima novena",
  "vigésima",
  "vigésima primera",
  "vigésima segunda",
  "vigésima tercera",
  "vigésima cuarta",
  "vigésima quinta",
  "vigésima sexta",
  "vigésima séptima",
  "vigésima octava",
  "vigésima novena",
  "trigésima",
  "trigésima primera",
  "trigésima segunda",
  "trigésima tercera",
  "trigésima cuarta",
  "trigésima quinta",
  "trigésima sexta",
  "trigésima séptima",
  "trigésima octava",
  "trigésima novena",
  "cuadragésima",
  "cuadragésima primera",
  "cuadragésima segunda",
  "cuadragésima tercera",
  "cuadragésima cuarta",
  "cuadragésima quinta",
  "cuadragésima sexta",
  "cuadragésima séptimo",
  "cuadragésima octava",
  "cuadragésima novena",
  "quincuagésima",
  "quincuagésima primera",
  "quincuagésima segunda",
  "quincuagésima tercera",
  "quincuagésima cuarta",
  "quincuagésima quinta",
  "quincuagésima sexta",
  "quincuagésima séptima",
  "quincuagésima octava",
  "quincuagésima novena",
  "sexagésima",
  "sexagésima primera",
  "sexagésima segunda",
  "sexagésima tercera",
  "sexagésima cuarta",
  "sexagésima quinta",
  "sexagésima sexta",
  "sexagésima séptima",
  "sexagésima octava",
  "sexagésima novena",
  "septuagésima",
  "septuagésima primera",
  "septuagésima segunda",
  "septuagésima tercera",
  "septuagésima cuarta",
  "septuagésima quinta",
  "septuagésima sexta",
  "septuagésima séptima",
  "septuagésima octava",
  "septuagésima novena",
  "octogésima",
  "octogésima primera",
  "octogésima segunda",
  "octogésima tercera",
  "octogésima cuarta",
  "octogésima quinta",
  "octogésima sexta",
  "octogésima séptima",
  "octogésima octava",
  "octogésima novena",
  "nonagésima",
  "nonagésima primera",
  "nonagésima segunda",
  "nonagésima tercera",
  "nonagésima cuarta",
  "nonagésima quinta",
  "nonagésima sexta",
  "nonagésima séptima",
  "nonagésima octava",
  "nonagésima novena",
  "centésima"
]
